import type { CSSProperties, ReactNode } from 'react';

interface PortraitProps {
  seed?: string;
  label?: string;
  sub?: string;
  style?: CSSProperties;
  corner?: number;
  children?: ReactNode;
  className?: string;
}

export function Portrait({ seed = 'a', label, sub, style = {}, corner = 0, children, className }: PortraitProps) {
  const h = (seed.charCodeAt(0) * 37 + (seed.charCodeAt(1) || 0) * 13) % 360;
  const hue = 15 + (h % 45);
  const hue2 = hue + 20;

  return (
    <div className={className} style={{
      position: 'relative',
      background: `linear-gradient(135deg, oklch(0.82 0.08 ${hue}) 0%, oklch(0.68 0.12 ${hue2}) 55%, oklch(0.54 0.1 ${hue2 + 15}) 100%)`,
      overflow: 'hidden',
      borderRadius: corner,
      ...style,
    }}>
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.12,
        background: 'repeating-linear-gradient(45deg, rgba(255,255,255,0.3) 0 2px, transparent 2px 24px)',
      }} />
      <div style={{
        position: 'absolute', width: '80%', height: '60%',
        top: '15%', left: '10%',
        background: `radial-gradient(ellipse, oklch(0.78 0.13 ${hue + 30}) 0%, transparent 70%)`,
        mixBlendMode: 'soft-light', opacity: 0.9,
      }} />
      {label && (
        <div style={{
          position: 'absolute', left: 10, top: 10,
          fontFamily: '"Geist Mono", monospace', fontSize: 10, letterSpacing: 0.5,
          color: 'rgba(255,255,255,0.85)', textTransform: 'uppercase',
          background: 'rgba(0,0,0,0.2)', padding: '3px 6px', borderRadius: 3,
          backdropFilter: 'blur(4px)',
        }}>
          {label}{sub && <span style={{ opacity: 0.7 }}> · {sub}</span>}
        </div>
      )}
      {children}
    </div>
  );
}
